import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "max-w-4xl mx-auto p-4" }
const _hoisted_2 = { class: "space-y-4" }
const _hoisted_3 = { class: "text-sm text-gray-600" }
const _hoisted_4 = { class: "text-sm font-semibold" }
const _hoisted_5 = { class: "text-sm text-gray-600" }
const _hoisted_6 = { class: "text-sm text-right" }
const _hoisted_7 = {
  key: 0,
  class: "text-red-600"
}
const _hoisted_8 = {
  key: 1,
  class: "text-green-600"
}
const _hoisted_9 = { class: "ml-2" }

import { ref } from 'vue';

interface AgendaEntry {
  date: string;
  event: string;
  location: string;
  status: string;
  flag: string;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'agenda-view',
  setup(__props) {

const agendaEntries = ref<AgendaEntry[]>([
  {
    date: '20-09-2024',
    event: 'ONE LIFE X USHUAÏA',
    location: 'IBIZA',
    status: 'TICKETS',
    flag: '🇪🇸',
  },
  {
    date: '20-09-2024',
    event: 'LIMELIGHT',
    location: 'BELFAST',
    status: 'TICKETS',
    flag: '🇬🇧',
  },
  {
    date: '21-09-2024',
    event: 'DISTRICT X FESTIVAL',
    location: 'DUBLIN',
    status: 'SOLD OUT',
    flag: '🇮🇪',
  },
]);


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[0] || (_cache[0] = _createElementVNode("h2", { class: "text-3xl font-bold mb-8 text-center" }, "AGENDA", -1)),
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(agendaEntries.value, (entry, index) => {
        return (_openBlock(), _createElementBlock("div", {
          key: index,
          class: "grid grid-cols-4 gap-4 items-center border-b-2 border-gray-200 py-2"
        }, [
          _createElementVNode("div", _hoisted_3, _toDisplayString(entry.date), 1),
          _createElementVNode("div", _hoisted_4, _toDisplayString(entry.event), 1),
          _createElementVNode("div", _hoisted_5, _toDisplayString(entry.location), 1),
          _createElementVNode("div", _hoisted_6, [
            (entry.status === 'SOLD OUT')
              ? (_openBlock(), _createElementBlock("span", _hoisted_7, _toDisplayString(entry.status), 1))
              : (_openBlock(), _createElementBlock("span", _hoisted_8, _toDisplayString(entry.status), 1)),
            _createElementVNode("span", _hoisted_9, _toDisplayString(entry.flag), 1)
          ])
        ]))
      }), 128))
    ]),
    _cache[1] || (_cache[1] = _createElementVNode("button", { class: "mt-8 px-4 py-2 border border-gray-400 hover:border-gray-600 transition-colors text-sm mx-auto block" }, " SHOW ALL ", -1))
  ]))
}
}

})